import { render } from "./CloseBtn.vue?vue&type=template&id=52a2c7ac&scoped=true"
import script from "./CloseBtn.vue?vue&type=script&lang=js"
export * from "./CloseBtn.vue?vue&type=script&lang=js"

import "./CloseBtn.vue?vue&type=style&index=0&id=52a2c7ac&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a2c7ac"]])

export default __exports__